import { OnInit } from '@angular/core';
import { ContactsService } from '../shared/services/contacts.service';
import { getCampaignsSelector, getOpenedTagGroupTooltipsSelector, getTagsSelector, getTempEditedFiltersSelector, getTempTagsSelector } from '../contacts.reducer';
import { Store } from '@ngrx/store';
import { CloseTagGroupTooltip, OpenTagGroupTooltip, SetFilterItemOpened, UpdateEditedFilterList } from '../contacts.actions';
var FiltersTagComponent = /** @class */ (function () {
    function FiltersTagComponent(contactsService, store) {
        var _this = this;
        this.contactsService = contactsService;
        this.store = store;
        this.store.select(getTagsSelector).subscribe(function (tagList) {
            _this.tagGroupsList = tagList;
        });
        this.store.select(getTempTagsSelector).subscribe(function (tempTagList) {
            var tags = !!tempTagList
                ? Object.entries(tempTagList).map(function (_a) {
                    var key = _a[0], value = _a[1];
                    if (value !== null) {
                        return value;
                    }
                })
                : [];
        });
        this.store.select(getCampaignsSelector).subscribe(function (projects) {
            _this.campaigns = projects;
        });
        this.store.select(getOpenedTagGroupTooltipsSelector).subscribe(function (openedTooltips) {
            _this.openedTagGroupTooltips = openedTooltips;
        });
        this.store.select(getTempEditedFiltersSelector).subscribe(function (editedFiltersList) {
            _this.editedFiltersList = editedFiltersList;
        });
    }
    FiltersTagComponent.prototype.ngOnInit = function () { };
    // addTag() {
    //   this.contactsService.showFilters();
    //   this.contactsService.showSearchFilters();
    //   this.contactsService.snapshotCallFinishType();
    // }
    FiltersTagComponent.prototype.removeFilterTag = function (tag) {
        this.store.dispatch(new SetFilterItemOpened(tag.source));
        if (tag.source === 'clientPhoneNumbers') {
            this.contactsService.switchOffClientsPhoneNumberFilter(tag);
        }
        else if (tag.callLengthsRange) {
            this.contactsService.switchOffCallLengthFilter(tag);
        }
        else {
            this.contactsService.switchOffOtherFilter(tag);
        }
        this.store.dispatch(new UpdateEditedFilterList());
        this.contactsService.useNewFilters();
    };
    FiltersTagComponent.prototype.getKeys = function (obj) {
        return Object.keys(obj);
    };
    FiltersTagComponent.prototype.openTagGroupTooltip = function (groupKey) {
        if (this.openedTagGroupTooltips && this.openedTagGroupTooltips.includes(groupKey)) {
            this.store.dispatch(new CloseTagGroupTooltip(groupKey));
        }
        else {
            this.store.dispatch(new OpenTagGroupTooltip(groupKey));
        }
    };
    FiltersTagComponent.prototype.isTooltipOpened = function (groupKey) {
        return this.openedTagGroupTooltips ? this.openedTagGroupTooltips.includes(groupKey) : false;
    };
    FiltersTagComponent.prototype.editFilterGroup = function (groupKey) {
        this.contactsService.openFilterToEdit(groupKey);
    };
    FiltersTagComponent.prototype.translateKeyName = function (filterName) {
        return this.contactsService.getFilterTitle(filterName);
    };
    FiltersTagComponent.prototype.removeCollection = function (groupKey) {
        var _this = this;
        if (groupKey === 'callLengths') {
            this.contactsService.removeCallLengthCollection();
            this.store.dispatch(new UpdateEditedFilterList());
        }
        else {
            this.tagGroupsList[groupKey].forEach(function (tag) {
                _this.removeFilterTag(tag);
            });
        }
    };
    FiltersTagComponent.prototype.tooltipExit = function ($event) {
        var _this = this;
        if ($event.target.className !== 'group-length-label' &&
            $event.target.className !== 'filter-tag-group-wrapper ng-star-inserted' &&
            $event.target.className !== 'filter-tag-group-title' &&
            $event.target.className !== 'material-icons filter-tag-group-edit' &&
            this.openedTagGroupTooltips.length) {
            Object.keys(this.tagGroupsList).forEach(function (key) {
                _this.store.dispatch(new CloseTagGroupTooltip(key));
            });
        }
    };
    return FiltersTagComponent;
}());
export { FiltersTagComponent };
